var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('profile',{on:{"updateUser":function($event){return _vm.updateUser($event)}}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('update-password',{on:{"UpdatePassword":function($event){return _vm.UpdatePassword($event)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }